import createPersistedState from 'vuex-persistedstate'

import Vue from 'vue'
import Vuex from 'vuex'

import authentication from './modules/authentication'
import analysis from './modules/analysis'
import companies from './modules/companies'
import clients from './modules/clients'
import sedes from './modules/sedes'
import offices from './modules/offices'
import comisiones from './modules/comisiones'
import categories from './modules/categories'
import capacities from './modules/capacities'
import colors from './modules/colors'
import brands from './modules/brands'
import zonas from './modules/zonas'
import types from './modules/types'
import plans from './modules/plans'
import customers from './modules/customers'
import doctors from './modules/doctors'
import documents from './modules/documents'
import suppliers from './modules/suppliers'
import employees from './modules/employees'
import products from './modules/products'
import purchases from './modules/purchases'
import inventories from './modules/inventories'
import transfers from './modules/transfers'
import saleoptions from './modules/saleoptions'
import sales from './modules/sales'
import roles from './modules/roles';
import users from './modules/users';
import tills from './modules/tills';
import notifications from './modules/notifications';
import imeis from './modules/imeis';
import informar from './modules/informar';
import reportTransfers from './modules/report-transfers';
import reportSales from './modules/report-sales';
import vouchers from './modules/vouchers';
import banks from './modules/banks';
import accounts from './modules/accounts';
import reportPurchases from './modules/report-purchases';
import reportTills from './modules/report-tills';
import units from './modules/units';
import debts from './modules/debts';
import supplierAccounts from './modules/supplier-accounts';
import orders from './modules/orders';
import creditNotes from './modules/credit-notes';
import userSessions from './modules/user-sessions';
import storehouses from './modules/storehouses';
import services from './modules/services';
import stations from './modules/stations';
import commissions from './modules/commissions';
import ReportKardex from './modules/report-kardex';
import ReportProducts from './modules/report-products';
import ReportServices from './modules/report-services';
import Areas from './modules/areas';
import cotizaciones from './modules/cotizaciones';
import material from './modules/material';
import reactive from './modules/reactive';
import prosecution from './modules/prosecution'
import specialty from './modules/specialty'

import bonos from './modules/bonos'
import regimenes from './modules/regimenes'
import seguros from './modules/seguros'
import puestos from './modules/puestos'
import planillas from './modules/planillas'
import planillaDetalle from './modules/planillaDetalle'
import honorarios from './modules/honorarios'
import honorarioDetalle from './modules/honorarioDetalle'
import convenio from './modules/convenio'
import serviceSettings from './modules/service-settings'


Vue.use(Vuex)

export default new Vuex.Store({
    strict: true,
    state: {
    },
    modules: {
        accounts,
        analysis,
        areas: Areas,
        authentication,
        banks,
        brands,
        bonos, // incluido nuevo
        honorarios, // nuevo
        honorarioDetalle, // nuevo
        capacities,
        categories,
        colors,
        commissions,
        comisiones,
        companies,
        clients,
        "credit-notes": creditNotes,
        customers,
        doctors,
        debts,
        documents,
        employees,
        imeis,
        inventories,
        informar,
        notifications,
        offices,
        orders,
        plans,
        products,
        purchases,
        "report-kardex": ReportKardex,
        "report-products": ReportProducts,
        "report-purchases": reportPurchases,
        "report-sales": reportSales,
        "report-services": ReportServices,
        "report-tills": reportTills,
        "report-transfers": reportTransfers,
        regimenes, // nuevo
        roles,
        puestos, // nuevo
        planillas, // nuevo
        planillaDetalle, // nuevo
        seguros, // nuevo
        sales,
        cotizaciones,
        saleoptions,
        sedes,
        services,
        stations,
        storehouses,
        suppliers,
        "supplier-accounts": supplierAccounts,
        tills,
        transfers,
        types,
        units,
        users,
        "user-sessions": userSessions,
        vouchers,
        material,
        reactive,
        prosecution,
        zonas,
        specialty,
        convenio,
        "service-settings": serviceSettings,
    },
    mutations: {

    },
    actions: {

    },
    plugins: [
        createPersistedState(),
    ]
})
